import {DateRange} from './date-range';
import {PresetDateRange} from './presets';
import {DateRangeType, TimeUnit} from './types';

export const UNIFIED_UNITS = [
  TimeUnit.Minute,
  TimeUnit.Hour,
  TimeUnit.Day,
  TimeUnit.Week,
  TimeUnit.Month,
  TimeUnit.Quarter,
];
export class UnifiedWithPresetsDateRange extends DateRange {
  public static get presets(): PresetDateRange[] {
    return [
      PresetDateRange.Today,
      PresetDateRange.Yesterday,
      PresetDateRange.Last7Days,
      PresetDateRange.Last30Days,
      PresetDateRange.Last3Months,
      PresetDateRange.Last6Months,
      PresetDateRange.Last12Months,
    ];
  }

  public getDateRangeTypeOptions() {
    return [DateRangeType.RelativeAfter, DateRangeType.Between, DateRangeType.Since, DateRangeType.On];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return UNIFIED_UNITS;
  }

  public canUseRolling(): boolean {
    return [DateRangeType.Between, DateRangeType.On].includes(this.type);
  }
}
